"use client";

/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from "next-i18next";
import { useEffect, useRef, useState } from "react";
import HideIf from "../../../util/HideIf";
import styles from "./ShowMoreAndLessContainer.module.scss";

function ShowMoreAndLess(props: any) {
  const {
    style, contentDescription, onClick, className = "",
    defaultHeight = 15,
  } = props;
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const viewModeDivRef = useRef(null);
  const { t } = useTranslation("product");
  useEffect(() => {
    if (!(viewModeDivRef && viewModeDivRef.current)) {
      return;
    }
    const { scrollHeight } = viewModeDivRef.current;
    setShowButton(scrollHeight > defaultHeight);
  }, [contentDescription]);

  function toggleExpand(e: any) {
    e.preventDefault();
    setExpanded((_expanded: any) => !_expanded);
    if (onClick) {
      onClick();
    }
  }

  return (
    <div className={`${styles.mainContainer} ${className}`}>

      <div className={expanded ? styles.showAllContentDiv : styles.HideOverFlowContentDiv} style={style} ref={viewModeDivRef}>
        {contentDescription}
      </div>

      <HideIf show={showButton}>
        <p className={`p-t-15 p-r-20 font-14px ${!expanded ? styles.shadow : ""} ${styles.ExpanderContentFade}`}>
          <span className={styles.content} onClick={toggleExpand}>
            { expanded ? t("show less") : t("show more")}
            <i className={`p-l-5 fa fa-angle-${expanded ? "up" : "right"}`} />
          </span>
        </p>
      </HideIf>
    </div>
  );
}

export default ShowMoreAndLess;
